import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M3.854 1C2.26 1 1 2.336 1 3.94v7.25c0 1.603 1.259 2.94 2.854 2.94v-1.576c-.696 0-1.295-.591-1.295-1.365V3.94c0-.772.6-1.363 1.295-1.363H10.1c.696 0 1.295.59 1.295 1.364v5.38h1.559V3.94C12.954 2.336 11.695 1 10.1 1H3.854Z M4.915 11.766c0-.87.698-1.575 1.56-1.575h6.965c.862 0 1.56.705 1.56 1.575v1.659c0 .87-.698 1.575-1.56 1.575H6.474c-.86 0-1.56-.705-1.56-1.575v-1.659Zm4.681.532v-1.057H8.21v1.591a.402.402 0 0 1-.4.404c-.22 0-.4-.18-.4-.404v-1.591h-.936a.522.522 0 0 0-.52.525v1.659c0 .29.233.525.52.525h6.966c.288 0 .52-.236.52-.525v-1.659a.522.522 0 0 0-.52-.525h-.858v1.057a.402.402 0 0 1-.4.404c-.22 0-.4-.18-.4-.404v-1.057h-1.386v1.057a.402.402 0 0 1-.4.404c-.22 0-.4-.18-.4-.404Z';
const draw24px =
  'M17 4H4a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5h3v1.5H4a2 2 0 0 1-2-2v-13a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2v9h-1.5v-9A.5.5 0 0 0 17 4Z M22 17a1.5 1.5 0 0 0-1.5-1.5h-10A1.5 1.5 0 0 0 9 17v3a1.5 1.5 0 0 0 1.5 1.5h10A1.5 1.5 0 0 0 22 20v-3Zm-9-.2h1v1.4a.5.5 0 1 0 1 0v-1.4h1v1.4a.5.5 0 1 0 1 0v-1.4h1v.7a.5.5 0 0 0 1 0v-.7h1.5c.11 0 .2.09.2.2v3a.2.2 0 0 1-.2.2h-10a.2.2 0 0 1-.2-.2v-3c0-.11.09-.2.2-.2H12v1.9a.5.5 0 1 0 1 0v-1.9Z';
const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const SurfaceMeasureIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'surfaceMeasure')) as IconWithRender;

SurfaceMeasureIcon.displayName = 'SurfaceMeasureIcon';
SurfaceMeasureIcon.propTypes = Icon.propTypes;
SurfaceMeasureIcon.renderIcon = (props) => <SurfaceMeasureIcon {...props} />;
export default SurfaceMeasureIcon;
